module.exports = {
    // basic
    'contact': 'contact',
    'contacts': 'contacts',
    'phone': 'phone',
    'last-upload-date': 'last upload date',
    'show-recent-used': 'Show Only Most Recently Used',
    // raw
    'enter-contact-name': 'Please enter the name for this contact.',
    'confirm-delete-selected-contacts': `The selected contacts will be deleted.  \r\nContinue?`,
    // template
};
